<template>

  <form id="payment_form" ref="frmPayment">
    <fieldset class="fields_payment fields-step-4">
      <legend class="bar">{{ copydeck.component_payment.txt_invoice_coords[ lang ] }}</legend>

      <div class="form_group">
        <label for="invoice-cc-firstname"
               :class="checkErrorClass('invoice-cc-firstname')">{{
            copydeck.component_payment.txt_coords_firstname[ lang ]
          }} :</label>
        <input type="text"
               data-type="invoice_info"
               data-link="#hidden_invoice_cc_firstname"
               id="invoice-cc-firstname"
               name="invoice-cc-firstname"
               v-model="invoice.firstname"
               required="">
        <div class="status-error"
             :aria-hidden="!hasError('invoice-cc-firstname')"
             v-show="hasError('invoice-cc-firstname')"> {{ getErrorMessage( 'invoice-cc-firstname' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <div class="form_group">
        <label for="invoice-cc-lastname"
               :class="checkErrorClass('invoice-cc-lastname')">{{
            copydeck.component_payment.txt_coords_lastname[ lang ]
          }} :</label>
        <input type="text"
               data-type="invoice_info"
               data-link="#hidden_invoice_cc_lastname"
               id="invoice-cc-lastname"
               name="invoice-cc-lastname"
               v-model="invoice.lastname"
               required="">
        <div class="status-error"
             :aria-hidden="!hasError('invoice-cc-lastname')"
             v-show="hasError('invoice-cc-lastname')"> {{ getErrorMessage( 'invoice-cc-lastname' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <div class="form_group">
        <label for="invoice-cc-address1"
               :class="checkErrorClass('invoice-cc-address1')">{{
            copydeck.component_payment.txt_coords_address1[ lang ]
          }} :</label>
        <input type="text"
               data-type="invoice_info"
               data-link="#hidden_invoice_cc_address1"
               id="invoice-cc-address1"
               name="invoice-cc-address1"
               v-model="invoice.address1"
               required="">
        <div class="status-error"
             :aria-hidden="!hasError('invoice-cc-address1')"
             v-show="hasError('invoice-cc-address1')"> {{ getErrorMessage( 'invoice-cc-address1' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <div class="form_group">
        <label for="invoice-cc-address2"
               :class="checkErrorClass('invoice-cc-address2')">{{
            copydeck.component_payment.txt_coords_address2[ lang ]
          }} :</label>
        <input type="text"
               data-type="invoice_info"
               data-link="#hidden_invoice_cc_address2"
               id="invoice-cc-address2"
               name="invoice-cc-address2"
               v-model="invoice.address2">
        <div class="status-error"
             :aria-hidden="!hasError('invoice-cc-address2')"
             v-show="hasError('invoice-cc-address2')"> {{ getErrorMessage( 'invoice-cc-address2' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <div class="form_group">
        <label for="invoice-cc-city"
               :class="checkErrorClass('invoice-cc-city')">{{ copydeck.component_payment.txt_coords_city[ lang ] }}
          :</label>
        <input type="text"
               data-type="invoice_info"
               data-link="#hidden_invoice_cc_city"
               id="invoice-cc-city"
               name="invoice-cc-city"
               v-model="invoice.city"
               required="">
        <div class="status-error"
             :aria-hidden="!hasError('invoice-cc-city')"
             v-show="hasError('invoice-cc-city')"> {{ getErrorMessage( 'invoice-cc-city' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <div class="form_group">
        <label for="invoice-cc-postal-code"
               :class="checkErrorClass('invoice-cc-postal-code')">{{
            copydeck.component_payment.txt_coords_postal_code[ lang ]
          }} :</label>
        <input type="text"
               data-type="invoice_info"
               data-link="#hidden_invoice_cc_postal_code"
               id="invoice-cc-postal-code"
               name="invoice-cc-postal-code"
               v-model="invoice.postal_code"
               required="">
        <div class="status-error"
             :aria-hidden="!hasError('invoice-cc-postal-code')"
             v-show="hasError('invoice-cc-postal-code')"> {{ getErrorMessage( 'invoice-cc-postal-code' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <div class="form_group">
        <label for="hidden_invoice_cc_province"
               :class="checkErrorClass('hidden_invoice_cc_province')">{{
            copydeck.component_payment.txt_coords_province[ lang ]
          }} :</label>

        <select data-type="invoice_info"
                data-link="#hidden_invoice_cc_province"
                id="invoice-cc-province"
                name="invoice-cc-province"
                required=""
                v-model="invoice.province">
          <option value="QC">Québec</option>
          <option value="AB">Alberta</option>
          <option value="BC">Colombie-Britannique</option>
          <option value="PE">Île-du-Prince-Édouard</option>
          <option value="MB">Manitoba</option>
          <option value="NB">Nouveau-Brunswick</option>
          <option value="NS">Nouvelle-Écosse</option>
          <option value="NU">Nunavut</option>
          <option value="ON">Ontario</option>
          <option value="SK">Saskatchewan</option>
          <option value="NL">Terre-Neuve et Labrador</option>
          <option value="NT">Territoires du Nord-Ouest</option>
          <option value="YT">Yukon</option>

        </select>
        <div class="status-error"
             :aria-hidden="!hasError('invoice-cc-province')"
             v-show="hasError('invoice-cc-province')"> {{ getErrorMessage( 'invoice-cc-province' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <div class="form_group">
        <label for="hidden_invoice_cc_country"
               :class="checkErrorClass('hidden_invoice_cc_country')">{{
            copydeck.component_payment.txt_coords_country[ lang ]
          }} :</label>
        <!--                                <input type="text" data-type="invoice_info" data-link="#hidden_invoice_cc_country" id="invoice-cc-country" name="invoice-cc-country" value="-->
        <!--" required />-->
        <select data-type="invoice_info"
                data-link="#hidden_invoice_cc_country"
                id="invoice-cc-country"
                name="invoice-cc-country"
                required=""
                v-model="invoice.country">
          <option value="CA">Canada</option>
        </select>
        <div class="status-error"
             :aria-hidden="!hasError('invoice-cc-country')"
             v-show="hasError('invoice-cc-country')"> {{ getErrorMessage( 'invoice-cc-country' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <div class="form_group">
        <label for="invoice-email"
               :class="checkErrorClass('invoice-email')" v-html="copydeck.component_payment.txt_coords_email[ lang ]"></label>
        <input type="text"
               data-type="invoice_info"
               data-link="#hidden_invoice_email"
               id="invoice-email"
               name="invoice-email"
               placeholder="exemple@exemple.ca"
               required=""
               v-model="invoice.email">
        <div class="status-error"
             :aria-hidden="!hasError('invoice-email')"
             v-show="hasError('invoice-email')"> {{ getErrorMessage( 'invoice-email' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <div class="form_group">
        <label for="invoice-phone"
               :class="checkErrorClass('invoice-phone')">{{ copydeck.component_payment.txt_coords_phone[ lang ] }}&nbsp;:</label>
        <input type="tel"
               data-type="invoice_info"
               data-link="#hidden_invoice_phone"
               id="invoice-phone"
               name="invoice-phone"
               placeholder="(xxx) xxx-xxxx"
               required=""
               v-model="invoice.phone">
        <div class="status-error"
             :aria-hidden="!hasError('invoice-phone')"
             v-show="hasError('invoice-phone')"> {{ getErrorMessage( 'invoice-phone' ) }}
        </div>
      </div>
      <!-- div.form_group -->

      <slot></slot>

    </fieldset>


    <fieldset class="fields_payment cc-fields fields-step-4">
      <legend class="bar">{{ copydeck.component_payment.txt_secure_payment[ lang ] }}</legend>

      <div class="form_group">
        <label for="payment-cc"
               :class="checkErrorClass('payment-cc')">{{
            copydeck.component_payment.txt_secure_credit_card_type[ lang ]
          }}&nbsp;:</label>
        <select id="payment-cc-type"
                name="payment-cc-type"
                data-type="invoice_info"
                required=""
                v-model="creditcard.type">
          <option selected="" disabled="">{{ copydeck.component_payment.txt_secure_choose[ lang ] }}&nbsp;
          </option>
          <option value="VI">Visa</option>
          <option value="MC">Mastercard</option>
        </select>
        <div class="status-error"
             :aria-hidden="!hasError('payment-cc-type')"
             v-show="hasError('payment-cc-type')"> {{ getErrorMessage( 'payment-cc-type' ) }}
        </div>
      </div>
      <!-- div.form_group -->


      <global-payment-card-info ref="refCardInfo" :errors="errors"></global-payment-card-info>

      <div class="form_group conditions_group">
        <div class="checkbox_wrapper">
          <input type="checkbox"
                 id="payment-conditions"
                 name="payment-conditions"
                 value="1"
                 data-type="invoice_info"
                 required="">
          <label for="payment-conditions" :class="checkErrorClass('payment-conditions') + '  payment-conditions-label'">
            <a :href="copydeck.page_gift_card.url_link_confidentiality[lang]"
               target="_blank">{{ copydeck.component_payment.txt_secure_condition[ lang ] }}
            </a>
          </label>
        </div>

        <div class="status-error"
             :aria-hidden="!hasError('payment-conditions')"
             v-show="hasError('payment-conditions')"> {{ getErrorMessage( 'payment-conditions' ) }}
        </div>
      </div>

      <!-- div.form_group -->
    </fieldset>

  </form>
</template>

<script>
export default {
  name : "Payment",
}
</script>

<script setup>

import { ref }               from "vue";
import { useMainStore }      from "../stores/main";
import { storeToRefs }       from "pinia";
import StripeCardInfo        from "./StripeCardInfo.vue";
import GlobalPaymentCardInfo from "./GlobalPaymentCardInfo.vue";

let store                                   = useMainStore();
let { copydeck, lang, invoice, creditcard } = storeToRefs( store );

let props = defineProps( [ "errors" ] );
defineExpose( { getForm, showFirstError, validateCreditInfo } )
let frmPayment  = ref( null );
let refCardInfo = ref( null );

function hasError ( strKey )
{
  let errors   = props?.errors ?? {};
  let strError = errors[ strKey ]

  if ( strError === undefined )
    return false;


  return strError !== "";
}

function getErrorMessage ( strKey )
{
  let errors   = props?.errors ?? {};
  let strError = errors[ strKey ]

  if ( copydeck.value.form_errors[ strError ] )
  {
    return copydeck.value.form_errors[ strError ][ lang.value ];
  }

  return "";
}

function checkErrorClass ( strKey )
{
  return hasError( strKey ) ? "status-error" : "";
}

function getForm ()
{
  return frmPayment.value;
}

function showFirstError ()
{


  // 2023-06-29 MB : There is a layout shift/transition, so it kept being "off"
  // because it was taking its screen position measures during the animation
  // also, fixed headers and anchor jumps = :'(
  // so went with measures so that I could add an offset

  setTimeout( () =>
  {
    const statusErrors   = document.querySelectorAll( "#payment_form .status-error" );

    const firstError = Array.from(statusErrors).find( stErr => stErr.style.display !== 'none');

    const firstErrorY  = firstError.getBoundingClientRect().top;
    const headerHeight = document.querySelector( '#reservations_steps_nav' ).getBoundingClientRect().height;

    let scrollToY = window.scrollY + firstErrorY - headerHeight - 80; // 80 = buffer


    window.scrollTo( {
      top      : scrollToY,
      left     : 0,
      behavior : 'smooth',
    } );

    // intoView.scrollIntoView( { behavior : "smooth" } );
  }, 200 );
}

function validateCreditInfo ()
{
  return refCardInfo.value.validateCreditInfo();
}
</script>
